/**
 * Maps role identifiers to their properly formatted display names
 */
const roleDisplayNames: Record<string, string> = {
  admin: 'Admin',
  limitedadmin: 'Limited Admin',
  businessmanager: 'Business Manager',
  primeapprover: 'Prime Approver',
};

/**
 * Parses a role string and returns the properly formatted role name
 * @param role - The role string (may be in camelCase or without spaces)
 * @returns The formatted role name with proper spacing, or the original string if no match is found
 */
export const parseRoleName = (role: string): string => {
  if (!role) {
    return role;
  }

  // Convert to lowercase to handle any case variations
  const normalizedRole = role.toLowerCase();

  // Return the mapped display name or the original string if no match
  return roleDisplayNames[normalizedRole] ?? role;
};
